/* src/app/private/modules/contacts/contacts.component.scss */
/*# sourceMappingURL=contacts.component.css.map */
